<template>
  <div class="my-info">
    <div class="nav">
      <p :class="{'default':(changBg===1)}" @click="(changBg=1)">我的资料</p>
      <p :class="{'default':(changBg===2)}" @click="(changBg=2)">修改密码</p>
    </div>
    <div class="info">
      <el-form :model="ruleForm" label-width="100px" v-if="(changBg===1)">
        <el-form-item label="用户账号">
          <el-input :disabled="true" v-model="userName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="用户昵称">
          <el-input :disabled="true" v-model="ruleForm.nickname">
            <template  slot="append">
              <el-button class="revise" icon="el-icon-edit-outline" @click="reviseName">
                {{textName === 0 ? '修改昵称' : textName==="deviceId" ? '取消修改' : "修改昵称"}}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="新昵称" v-show="showName">
          <el-input v-model="newName" ></el-input>
        </el-form-item>
        <el-form-item label="认证状态">
          <el-input :disabled="true" v-model="ruleForm.realstatus">
            <template  slot="append">
              <el-button class="certificate" icon="el-icon-edit-outline" v-if="ruleForm.realstatus == '未认证'" @click="goReal">立即认证</el-button>
              <el-button class="certificate" icon="el-icon-circle-check" type="success" v-else>已认证</el-button>
            </template>
          </el-input>
        </el-form-item> -->
        <!-- <el-button class="preserve" @click="preserveBtn(newName)">保存</el-button> -->
      </el-form>
      <el-form :model="pwdForm" label-width="90px" ref="pwdForm" v-if="(changBg===2)">
        <el-form-item label="手机号">
          <el-input placeholder="请输用户户手机号" v-model="pwdForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input placeholder="请输入新密码" type="password" v-model="pwdForm.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input placeholder="请确认密码" type="password" v-model="pwdForm.passwords"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="imageVerification">
          <el-input placeholder="请输入图形码" v-model="pwdForm.imageVerification"></el-input>
          <img :src="imgCode" @click="changeImg" alt="" class="real-img"/>
        </el-form-item>
        <el-form-item label="手机验证">
          <el-input placeholder="请输入验证码" v-model="pwdForm.telCode">
            <template slot="append">
              <el-button @click="getcode(pwdForm)" v-show="show">
                获取验证码
              </el-button>
              <el-button v-show="!show">
                {{ times }} s
              </el-button>
            </template>
          </el-input>

        </el-form-item>
        <el-button @click="pwdBtn(pwdForm)" class="password-button">保存</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {getPasswordById, getReaderById, telVerification, updateReaderById, verified,} from "../../../utils/router/reader.api";

  export default {
    data() {
      return {
        changBg: 1,
        ruleForm: {
          realstatus: "未实名认证",
          nickname: "",
          id: "",
        },
        Certificate: {
          id: "",
          imageVerification: "",
          identityDocument: "",
          realName: "",
        },
        userName: "",
        dialogVisible: false,
        showName: false,
        textName: "",
        newName: "",
        showBtn: 0,
        imgCode: "/portal/reader/imageVerification",
        rules: {
          identityDocument: [
            {
              required: true,
              message: "请输入18位的身份证号",
              trigger: "blur",
              min: 18,
              max: 18,
            },
          ],
          realName: [
            {required: true, message: "请输入", trigger: "blur", min: 2},
          ],
          imageVerification: [
            {
              required: true,
              message: "请输入图形中的数字",
              trigger: "blur",
              min: 4,
              max: 4,
            },
          ],
        },
        pwdForm: {},
        show: true,
        times: "",
        pwdName: "",
      };
    },
    methods: {
      getInfo() {
        getReaderById({
          id: this.$store.state.userInfo.userId,
        }).then((res) => {
          if (res && res.data.code === 200) {
            this.ruleForm.id = res.data.data.id;
            this.ruleForm.nickname = res.data.data.nickname;
            this.ruleForm.identityDocument = res.data.data.identityDocument;
            this.ruleForm.realName = res.data.data.realName;
            this.pwdName =
              res.data.data.userName.substr(0, 3) +
              "****" +
              res.data.data.userName.substr(7);
            this.userName = res.data.data.userName.replace(
              /^(\d{3})\d{4}(\d+)/,
              "$1****$2"
            );
            // console.log(res.data.data);
            if (res.data.data.realstatus == 1) {
              this.ruleForm.realstatus = "已认证";
            }
          }
        });
      },
      changeImg() {
        let num = Math.ceil(Math.random() * 10);
        this.imgCode = "/portal/reader/imageVerification?" + num;
      },
      goReal() {
        this.dialogVisible = true;
      },
      certificateBtn(row, item) {
        verified({
          id: row.id,
          imageVerification: item.imageVerification,
          identityDocument: item.identityDocument,
          realName: item.realName,
        }).then((res) => {
          if (res && res.data.code === 200) {
            this.$alert("认证成功");
            this.realBool = false;
            this.getUserInfo();
          } else {
            this.$alert(res.data.message);
            this.changeImg();
          }
        });
      },
      reviseName() {
        this.showBtn++;
        if (this.showBtn % 2 == 0) {
          this.showName = false;
          this.textName = "name";
        } else {
          this.showName = true;
          this.textName = "deviceId";
        }
      },
      preserveBtn(row) {
        updateReaderById({
          id: this.$store.state.userInfo.userId,
          nickname: row,
        }).then((res) => {
          if (res && res.data.code == 200) {
            this.showName = false;
            this.textName = "name";
            this.$alert("昵称修改成功", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$message({
                  type: "info",
                  message: `action: ${action}`,
                });
                location.reload();
              },
            });
          } else {
            this.$alert(res.data.message);
          }
        });
      },
      // 获取验证码
      getcode(row) {
        telVerification({
          tel: row.userName,
          imageVerification: row.imageVerification,
        }).then((res) => {
          if (res.data.code === 200) {
            const TIME_TIMES = 60;
            if (!this.timer) {
              this.times = TIME_TIMES;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.times > 0 && this.times <= TIME_TIMES) {
                  this.times--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$alert(res.data.message);
          }
        });
      },
      // 密码修改
      pwdBtn(row) {
        getPasswordById({
          userName: this.$store.state.userInfo.userName,
          password: this.$md5(row.password),
          telCode: row.telCode,
        }).then((res) => {
          if (res && res.data.code === 200) {
            this.$alert("修改成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$refs.UserLogin.openDialog(false);
              },
            });
          } else {
            this.$alert("修改失败！" + res.data.message);
          }
        });
      },
    },
    mounted() {
      this.getInfo();
    },
  };
</script>

<style lang="less" scoped>
  .my-info {
    height: 31.25rem;
    // padding-top: 2.083rem;
    background: #fff;
    padding: 2.083rem 1.563rem;

    .nav {
      height: 2.083rem;
      border-bottom: 0.124rem solid #b1222b;
      display: flex;

      p {
        width: 6.25rem;
        cursor: pointer;
        padding-top: 8px;
        text-align: center;
      }

      .default {
        background: #b1222b;
        border-radius: 0.313rem 0.313rem 0 0;
        color: #fff;
      }
    }

    .info {
      padding-top: 2.604rem;

      /deep/ .el-form-item__label {
        color: #909090;
        font-size: 0.833rem;
        line-height: 2.604rem;
        text-align: left;
      }

      /deep/ .el-input {
        width: 20.833rem;
        height: 2.604rem;
        position: relative;

        .el-input__inner {
          // width: 20.833rem;
          height: 2.604rem;
          border: solid 0.052rem #dcdcdc;
        }

        .revise {
          height: 2.604rem;
          top: 1px;
        }
      }

      .certificate {
        width: 7.25rem;
        height: 2.604rem;
        // position: absolute;
        // left: 13.6rem;
      }

      .preserve,
      .password-button {
        width: 6.25rem;
        height: 2.396rem;
        background-color: #b1222b;
        border-radius: 0.208rem;
        color: #fff;
        cursor: pointer;
        font-size: 0.833rem;
        letter-spacing: 0.104rem;
        margin-left: 8.35rem;
      }

      .real-img {
        height: 2.396rem;
        position: absolute;
        left: 14.452rem;
        top: 0.124rem;
      }

      .password-button {
        margin-left: 7.52rem;
      }
    }
  }
</style>
